/* Ghost's comments-ui renders the logged-out sign-up gate inside a same-origin
   `srcdoc` iframe with its own self-contained styles, so the main theme
   stylesheet never reaches it. There's no supported way to override its copy,
   so this injects a small stylesheet directly into the iframe's document,
   collapsing the original strings to font-size: 0 and replacing them via
   ::before/::after. Both title variants ("Start the conversation" /
   "Join the discussion") and both member-gate variants (free/paid) share one
   replacement, since selectors can't key off which text actually rendered.

   Sizes are read from each element's own computed style right before it's
   collapsed (rather than guessed) so the replacement text renders at
   exactly the size/weight the original copy did.

   comments-ui itself loads via a `defer` script, which creates
   #ghost-comments-root (and the iframe inside it) only once that external
   script has downloaded and run — well after this file (a plain, non-defer
   script at the bottom of the page) has already executed. So everything
   here has to poll rather than assume the container exists yet. */
(function () {
    const wrapper = document.querySelector('.gh-comments');
    if (!wrapper) return;

    const replacements = [
        {selector: '[data-testid="cta-box"] h1', text: 'Say Something. Ruin It For Everyone.', pseudo: 'after'},
        {selector: '[data-testid="cta-box"] p:first-of-type', text: 'Free commenting was tried. It did not go well. Become a paid member of Why We Can\'t Have Nice Things to post here.', pseudo: 'before', display: 'inline-block'},
        {selector: '[data-testid="signup-button"]', text: 'Pay Up', pseudo: 'after'},
        {selector: '[data-testid="cta-box"] p:last-of-type span', text: 'Already paid?', pseudo: 'after'},
        {selector: '[data-testid="signin-button"]', text: 'Prove it', pseudo: 'after'}
    ];
    const ruleCache = new Array(replacements.length).fill('');

    function ensureStyleTag(doc) {
        let style = doc.head.querySelector('[data-satire-comments]');
        if (!style) {
            style = doc.createElement('style');
            style.setAttribute('data-satire-comments', '');
            doc.head.appendChild(style);
        }
        return style;
    }

    function applyReplacements(doc) {
        if (!doc || !doc.head) return;
        const style = ensureStyleTag(doc);
        let changed = false;

        replacements.forEach(function (r, i) {
            const el = doc.querySelector(r.selector);
            if (!el || el.hasAttribute('data-satire-done')) return;

            /* Capture the real rendered size before collapsing it, so the
               replacement matches instead of relying on a guessed rem value. */
            const computed = doc.defaultView.getComputedStyle(el);
            const varName = '--satire-' + i;
            el.style.setProperty(varName + '-size', computed.fontSize);
            el.style.setProperty(varName + '-weight', computed.fontWeight);
            el.style.setProperty(varName + '-lh', computed.lineHeight);
            el.style.fontSize = '0';
            el.style.lineHeight = '0';
            el.setAttribute('data-satire-done', '');

            ruleCache[i] =
                r.selector + '::' + r.pseudo + '{' +
                'content:"' + r.text.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '";' +
                'font-size:var(' + varName + '-size);' +
                'font-weight:var(' + varName + '-weight);' +
                'line-height:var(' + varName + '-lh);' +
                (r.display ? 'display:' + r.display + ';' : '') +
                '}';
            changed = true;
        });

        if (changed) {
            style.textContent = ruleCache.join('\n');
        }
    }

    let attempts = 0;
    const maxAttempts = 200; /* ~30s at 150ms, covers slow script fetch + member-auth checks */
    const timer = setInterval(function () {
        attempts += 1;

        const iframe = wrapper.querySelector('#ghost-comments-root iframe');
        let doc = null;
        try {
            doc = iframe && iframe.contentDocument;
        } catch (e) {
            /* cross-origin, nothing we can do */
        }

        if (doc) {
            applyReplacements(doc);
        }

        if (attempts >= maxAttempts) {
            clearInterval(timer);
        }
    }, 150);
})();
